module.exports = __webpack_public_path__ + "img/living_1.d5934eb2.jpg";